import { useEffect } from 'react';

// Matches the <title> in public/index.html
const BASE_TITLE = 'Joe Wells - Outlaw Defense';

export const usePageTitle = (title?: string) => {
	useEffect(() => {
		// Pages without a title (e.g. Home) use the base title
		document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
	}, [title]);
};
